import * as React from 'react'
import ApexCharts from 'apexcharts'
import { render } from 'react-dom'
import { BsFillQuestionOctagonFill } from 'react-icons/bs'
import { GrUpdate } from 'react-icons/gr'
import { RxUpdate, RxReset } from 'react-icons/rx'
import { BiReset } from 'react-icons/bi'
import { AiFillRedditCircle } from 'react-icons/ai'
import { recalculatePeakAreasLC } from '../utility'

const CHROM_EXP_ID = "apex-chrom-exp"
const CHROM_STD_ID = "apex-chrom-std"
const CAL_CURVE_ID = "apex-cal-curve"
const DEFAULT_CAL_CURVE_MARKER_SIZE = 10
const EXP_CHROM_TITLE = "Experimental Chromatogram"
const ISTD_CHROM_TITLE = "Internal Standard Chromatogram"
const CAL_CURVE_MARKER_COLOR = "#4596B6"

const DUMMY_CAL_POINTS = {
    "calibration_points": [
        { "x": 2.5, "y": 0.008933758740781677 },
        { "x": 5.0, "y": 0.019894575423654918 },
        { "x": 25.0, "y": 0.1156144818937595 },
        { "x": 50.0, "y": 0.19752164761282145 },
        { "x": 100.0, "y": 0.4423283529057865 },
        { "x": 150.0, "y": 0.6687861649619784 },
        { "x": 200.0, "y": 0.8419866206674228 },
    ],
    "best_fit_line": [
        { "x": 2.5, "y": 0.008928767309048171 },
        { "x": 12.375, "y": 0.05265196550996561 },
        { "x": 22.25, "y": 0.09623830527959616 },
        { "x": 32.125, "y": 0.13968778661793985 },
        { "x": 42.0, "y": 0.18300040952499663 },
        { "x": 51.875, "y": 0.22617617400076653 },
        { "x": 61.75, "y": 0.2692150800452496 },
        { "x": 71.625, "y": 0.31211712765844574 },
        { "x": 81.5, "y": 0.35488231684035504 },
        { "x": 91.375, "y": 0.3975106475909774 },
        { "x": 101.25, "y": 0.44000211991031296 },
        { "x": 111.125, "y": 0.4823567337983615 },
        { "x": 121.0, "y": 0.5245744892551234 },
        { "x": 130.875, "y": 0.5666553862805982 },
        { "x": 140.75, "y": 0.6085994248747861 },
        { "x": 150.625, "y": 0.6504066050376873 },
        { "x": 160.5, "y": 0.6920769267693014 },
        { "x": 170.375, "y": 0.7336103900696289 },
        { "x": 180.25, "y": 0.7750069949386693 },
        { "x": 190.125, "y": 0.816266741376423 },
        { "x": 200.0, "y": 0.8573896293828897 }
    ]
}


export default ResultsPlotsAndOptions = (props) => {

    const SUBMISSION_ID = window.location.pathname.split("/")[2]

    const {
        isFia,
        selectedAnalyte,
        selectedSample,
        calcurveData,
        analyteData, // {sample:[], exp: [], istd: []}
        // key
    } = props

    // console.log("props from ResultsPlotsAndOptions: ", props)
    // console.log("selectedAnalyte from ResultsPlotsAndOptions: ", selectedAnalyte)
    console.log("selectedSample from ResultsPlotsAndOptions:::::: ", selectedSample)
    // console.log("calcurveData from ResultsPlotsAndOptions: ", calcurveData)
    // console.log("analyteData from ResultsPlotsAndOptions: ", analyteData)

    let _DUMMY_DATA = fetchSampleChromatogram(1, 1, 1)
    // console.log(_DUMMY_DATA)
    // _DUMMY_DATA.exp.map((d) => {
    //     d = [d["x"], d["y"]]
    // })
    // _DUMMY_DATA.istd.map((d) => {
    //     d = [d["x"], d["y"]]
    // })
    // console.log("after transformation:", _DUMMY_DATA)
    let DUMMY_DATA = [
        [0, 14],
        [1, 32],
        [2, 66],
        [3, 82],
        [4, 102],
        [5, 78],
        [6, 50],
        [7, 45],
        [8, 20],
        [9, 15],
        [10, 10],
    ]

    let SCATTER_DUMMY_DATA = [
        { x: 1, y: 2.14 }, { x: 1.2, y: 2.19 }, { x: 1.8, y: 2.43 }, { x: 2.3, y: 3.8 },
        { x: 4.9, y: 8.1 }, { x: 5.1, y: 9.4 }, { x: 7.1, y: 7.14 }
    ]
    let LINE_DUMMY_DATA = [{ x: 1, y: 2 }, { x: 2, y: 3 }, { x: 3, y: 4 }, { x: 4, y: 5 }, { x: 5, y: 6 }, { x: 6, y: 7 }, { x: 7, y: 8 }, { x: 8, y: 9 }, { x: 9, y: 10 }, { x: 10, y: 11 }]
    let CAL_CURVE_DUMMY_DATA = {
        SCATTER_DUMMY_DATA: [...DUMMY_CAL_POINTS["calibration_points"]],
        LINE_DUMMY_DATA: [...DUMMY_CAL_POINTS["best_fit_line"]]
    }

    const [expChromPlot, setExpChromPlot] = React.useState(null)
    const [stdChromPlot, setStdChromPlot] = React.useState(null)
    const [expChromSelection, setExpChromSelection] = React.useState([])
    const [stdChromSelection, setStdChromSelection] = React.useState([])
    const [calCurvePlot, setCalCurvePlot] = React.useState(null)
    const [applyToAllAnalytes, setApplyToAllAnalytes] = React.useState(false)
    const [applyToAllSamples, setApplyToAllSamples] = React.useState(false)
    const [applySmoothing, setApplySmoothing] = React.useState(false)
    const [calPointStates, setCalPointStates] = React.useState(new Array(7).fill(true))



    const handleChromSelection = (divId) => {
        let sampleIdx, sampleData;
        sampleIdx = analyteData.findIndex(d => d["sample_data"]["sample_id"] === selectedSample)
        if (divId === CHROM_EXP_ID) {
            sampleData = analyteData[sampleIdx]["exp_chrom_data"]
            updateChromatogram(expChromPlot, expChromSelection, sampleData.values)
        } else if (divId === CHROM_STD_ID) {
            sampleData = analyteData[sampleIdx]["istd_chrom_data"]
            updateChromatogram(stdChromPlot, stdChromSelection, sampleData.values)
        }
    }

    const handleCalPointHover = (chart, calPointStates, pointIdx, event) => {
        // console.log("data from handleCalPointHover: ", calPointStates, pointIdx, event)
        chart.updateOptions({
            markers: {
                discrete: calPointStates.map((state, i) => {
                    return {
                        seriesIndex: 0,
                        dataPointIndex: i,
                        fillColor: state ? CAL_CURVE_MARKER_COLOR : "#ffffff",
                        fillOpacity: state ? 1 : 0.5,
                        size: (i === pointIdx) ? (event === "enter" ? DEFAULT_CAL_CURVE_MARKER_SIZE * 2 : DEFAULT_CAL_CURVE_MARKER_SIZE) : DEFAULT_CAL_CURVE_MARKER_SIZE,
                    }
                })
            },
        })
    }

    const handleCalPointStateChange = (pointIdx, calCurvePlot) => {
        setCalPointStates(calPointStates.map((state, idx) => {
            if (idx === pointIdx) {
                return !state
            }
            return state
        }))
    }


    React.useEffect(() => {
        if (Object.keys(analyteData).length > 0) {
            // setExpChromPlot(updateChromatogramOnStateChange(expChromPlot, EXP_CHROM_TITLE, selectedAnalyte.name))
            setExpChromPlot(renderChromatogram(selectedSample, analyteData, CHROM_EXP_ID, EXP_CHROM_TITLE, selectedAnalyte.name, setExpChromSelection))
            setStdChromPlot(renderChromatogram(selectedSample, analyteData, CHROM_STD_ID, ISTD_CHROM_TITLE, selectedAnalyte.name, setStdChromSelection))

            { !isFia && document.getElementById("cal-curve-nav").click() }
            document.getElementById("chrom-nav").click()
        }
        if (!isFia && Object.keys(calcurveData).length > 0) {
            setCalCurvePlot(renderCalCurve(calcurveData, CAL_CURVE_ID, selectedAnalyte.name))
            //TODO: This is for a weird bug where the cal curve gets rendered twice initially but the second one disappears upon rerendering. This is a hacky fix.
            document.getElementById(CAL_CURVE_ID).childElementCount > 1 ? document.getElementById(CAL_CURVE_ID).removeChild(document.getElementById(CAL_CURVE_ID).lastChild) : null
            document.getElementById("chrom-nav").click()
            document.getElementById("cal-curve-nav").click()
        }
    }, [selectedAnalyte, selectedSample])

    // React.useEffect(() => {
    //     if (Object.keys(analyteData).length > 0) {
    //         setExpChromPlot(renderChromatogram(selectedSample, analyteData, CHROM_EXP_ID, EXP_CHROM_TITLE, selectedAnalyte.name, setExpChromSelection))
    //         setStdChromPlot(renderChromatogram(selectedSample, analyteData, CHROM_STD_ID, ISTD_CHROM_TITLE, selectedAnalyte.name, setStdChromSelection))
    //         !isFia ? document.getElementById("cal-curve-nav").click() : null
    //         document.getElementById("chrom-nav").click()
    //     }
    //     if (!isFia && Object.keys(calcurveData).length > 0) {
    //         setCalCurvePlot(renderCalCurve(calcurveData, CAL_CURVE_ID, selectedAnalyte.name))
    //         //TODO: This is for a weird bug where the cal curve gets rendered twice initially but the second one disappears upon rerendering. This is a hacky fix.
    //         document.getElementById(CAL_CURVE_ID).childElementCount > 1 ? document.getElementById(CAL_CURVE_ID).removeChild(document.getElementById(CAL_CURVE_ID).lastChild) : null
    //         document.getElementById("chrom-nav").click()
    //         document.getElementById("cal-curve-nav").click()
    //     }
    // }, [])

    // React.useEffect(() => {
    //     if (Object.keys(analyteData).length > 0) {
    //         setExpChromPlot(renderChromatogram(selectedSample, analyteData, CHROM_EXP_ID, EXP_CHROM_TITLE, setExpChromSelection))
    //         setStdChromPlot(renderChromatogram(selectedSample, analyteData, CHROM_STD_ID, ISTD_CHROM_TITLE, setStdChromSelection))
    //     }
    //     if (Object.keys(calcurveData).length > 0) setCalCurvePlot(renderCalCurve(calcurveData, CAL_CURVE_ID))
    // }, [])


    return (
        <div className="mb-3">

            {/* <div className="card d-flex flex-column p-1">
                <p>Options</p>
            </div> */}

            <div className="card p-1">

                <ul className="nav nav-pills nav-fill shadow" style={{ gap: '0.1rem' }} id="results-plots-tabs">
                    {!!!isFia && <li className={`nav-item`}>
                        <a className="nav-link rounded-start" id="cal-curve-nav" data-bs-toggle="pill" data-bs-target="#cal-curve-tab" style={{ color: "#212529" }}>Calibration Curve</a>
                    </li>}
                    <li className="nav-item">
                        <a className="nav-link rounded-end" id="chrom-nav" data-bs-toggle="pill" data-bs-target="#chromatogram-tab">Chromatogram</a>
                    </li>
                </ul>

                <div className="tab-content p-3">

                    {!!!isFia && <div className="tab-pane fade" id="cal-curve-tab" role="tabpanel" aria-labelledby="cal-curve-tab">
                        <div className="d-flex">
                            <div className="pe-3 w-50">
                                <div className="d-flex justify-content-between">
                                    <h4>Calibration Points</h4>
                                    {!!!isFia && <h4 className={`${selectedAnalyte.flags && 'bg-flag-dark'}`} style={{ borderRadius: '6px', padding: '1px 5px' }}>R<sup>2</sup> = {parseFloat(calcurveData["r_squared"]).toFixed(4)}</h4>}
                                </div>
                                <hr />
                                <div>
                                    {calcurveData?.cal_points ? calcurveData.cal_points.map((d, i) => {
                                        return (
                                            <div className="btn btn-outline-dark form-check d-flex align-items-center"
                                                key={`calcurve-check-container-${d.x}-${d.y}-${i}`}
                                                onMouseEnter={() => {
                                                    handleCalPointHover(calCurvePlot, calPointStates, i, "enter")
                                                }}
                                                onMouseLeave={() => {
                                                    handleCalPointHover(calCurvePlot, calPointStates, i, "leave")
                                                }}
                                                onClick={() => {
                                                    handleCalPointStateChange(i, calCurvePlot)
                                                }}
                                            >
                                                <input className="input"
                                                    type="checkbox"
                                                    checked={calPointStates[i]}
                                                    style={{ marginTop: '3px' }}
                                                    onChange={() => {
                                                        handleCalPointStateChange(i, calCurvePlot)
                                                        // setCalPointStates(calPointStates.map((state, idx) => {
                                                        //     if (idx === i) {
                                                        //         return !state
                                                        //     }
                                                        //     return state
                                                        // }))
                                                    }}
                                                    value={`${d.x}-${d.y}`}
                                                    key={`key-${d.x}-${d.y}-${i}`}
                                                />
                                                <label className="form-check-label" style={{ marginLeft: '3px' }} htmlFor={`key-${d.x}-${d.y}-${i}`}>
                                                    <span className="mx-2">{`Point ${i + 1}: [ ${d.x}, ${d.y.toFixed(4)} uM ]`}</span>
                                                </label>
                                            </div>
                                        )
                                    }) : null}
                                </div>
                                <hr />
                                <h4 className='mt-0'>Parameters:</h4>
                                <div className="btn btn-outline-dark form-check d-flex align-items-center"
                                    onClick={() => setApplyToAllAnalytes(!applyToAllAnalytes)}
                                >
                                    <input className="input"
                                        type="checkbox"
                                        style={{ marginTop: '3px' }}
                                        checked={applyToAllAnalytes}
                                        onChange={() => setApplyToAllAnalytes(!applyToAllAnalytes)}
                                        value="apply-to-all"
                                        key={`key-apply-to-all`} />
                                    <label className="form-check-label" style={{ marginLeft: '3px' }} htmlFor={`key-apply-to-all`}>
                                        <span className="mx-2">Apply to all analytes</span>
                                    </label>
                                </div>
                                <hr />
                                <div className="d-flex gap-1 w-100">
                                    <button className="btn w-50 btn-danger p-2 my-2 shadow-sm"
                                        onClick={() => {
                                            if (confirm("Are you sure you want to reset the calibration points?")) {
                                                // setCalPointStates(new Array(7).fill(true))
                                                // console.log("resetting calibration points")
                                            } else {
                                                return
                                            }
                                        }}
                                    >
                                        <RxReset className="mx-1 d-inline-block text-white align-text-bottom" style={{ fontSize: '1.2rem' }} />
                                        Reset Calibration Points
                                    </button>
                                    <button className="btn w-50 btn-primary-lc p-2 my-2 shadow-sm"
                                        onClick={() => {
                                            console.log(calPointStates, applyToAllAnalytes)
                                        }}
                                    >
                                        <BiReset className="mx-1 d-inline-block align-text-bottom" style={{ fontSize: '1.2rem' }} />
                                        Recalibrate Analyte
                                    </button>
                                </div>
                            </div>
                            <div id={CAL_CURVE_ID} className="w-50" style={{ width: '100%' }}></div>
                        </div>
                    </div>}

                    <div className="tab-pane fade" id="chromatogram-tab" role="tabpanel" aria-labelledby="chromatogram-tab">  {/* DO NOT make this a flex box as that messes up bootstrap tabs; instead use inline block displays on the child tab content elements */}
                        <div className="d-flex mt-2 mb-2 p-3 rounded-3 border">
                            {isFia ? <span className="text-muted mx-1" style={{ lineHeight: '2rem' }}><BsFillQuestionOctagonFill className="text-warning me-2 d-inline-block" style={{ fontSize: '1.5rem' }} />Click and drag to select a region of the <span className='fw-bold'>Experimental</span> chromatogram and set a new retention time window. Once you have redrawn the appropriate retention windows, please click on the blue button at the bottom to submit to recalculate peak areas. Please note that once submitted, processing times will vary depending on our server load. Your submission will be queued.</span> :
                                <span className="text-muted mx-1" style={{ lineHeight: '2rem' }}><BsFillQuestionOctagonFill className="text-warning me-2 d-inline-block" style={{ fontSize: '1.5rem' }} />Click and drag to select a region of the chromatogram and set a new retention time window. You may check the options below to apply the new retention window to all samples for this analyte and/or to apply smoothing. Once you have redrawn the appropriate retention windows and selected the appropriate options, please click on the blue button at the bottom to submit to recalculate peak areas. Please note that once submitted, processing times will vary depending on our server load. Your submission will be queued.</span>}
                        </div>
                        <hr />
                        <div className="w-50 d-inline-block pe-1">
                            <div id={CHROM_EXP_ID}></div>
                            <div className="d-flex justify-content-around w-100">
                                <button
                                    className="btn btn-danger w-50 shadow-sm mb-2 ms-1"
                                    onClick={() => handleChromSelection(CHROM_EXP_ID)}
                                >
                                    <RxUpdate className="mx-1 d-inline-block text-white align-text-bottom shadow-sm" style={{ fontSize: '1.2rem' }} />
                                    <span className="text-shadow">Re-draw Retention Window</span>
                                </button>
                            </div>
                        </div>
                        <div className="w-50 d-inline-block ps-1">
                            <div id={CHROM_STD_ID}></div>
                            <div className="d-flex justify-content-around w-100">
                                <button
                                    disabled={isFia}
                                    className="btn btn-success w-50 shadow-sm mb-2 me-1"
                                    onClick={() => handleChromSelection(CHROM_STD_ID)}
                                >
                                    <RxUpdate className="mx-1 d-inline-block text-white align-text-bottom shadow-sm" style={{ fontSize: '1.2rem' }} />
                                    <span className="text-shadow">Re-draw Retention Window</span>
                                </button>
                            </div>
                        </div>
                        <hr />
                        <div className="d-flex flex-column justify-content-around">
                            {!!!isFia && <>
                                <div className="d-flex flex-column justify-content-around w-25">
                                    <div>
                                        <h4 className="">Parameters:</h4>
                                    </div>
                                    <div className='btn btn-outline-dark form-check d-flex'
                                        onClick={() => setApplyToAllSamples(!applyToAllSamples)}
                                    >
                                        <input type="checkbox"
                                            id="check-apply-to-all-samples"
                                            checked={applyToAllSamples}
                                            // defaultChecked={applyToAllSamples}
                                            onChange={() => setApplyToAllSamples(applyToAllSamples)}
                                        />
                                        <label className="form-check-label mx-2" style={{ textAlign: 'start' }} htmlFor="check-apply-to-all-samples">
                                            <span>Apply new retention time window to all samples for this analyte</span>
                                        </label>
                                    </div>
                                    <div className='btn btn-outline-dark form-check d-flex'
                                        onClick={() => setApplySmoothing(!applySmoothing)}
                                    >
                                        <input type="checkbox"
                                            id="check-apply-smoothing"
                                            checked={applySmoothing}
                                            // readOnly={true}  
                                            // defaultChecked={applySmoothing}
                                            onChange={() => setApplySmoothing(applySmoothing)}
                                        />
                                        <label className="form-check-label mx-2" style={{ textAlign: 'start' }} htmlFor="check-apply-smoothing">
                                            <span>Apply smoothing to chromatograms</span>
                                        </label>
                                    </div>
                                </div>
                            </>}

                            <hr />
                            <button className="btn btn-primary-lc w-25 p-2 shadow-sm" style={{ alignSelf: 'flex-end' }}
                                onClick={async () => {
                                    let newRetentionWindow = [expChromSelection[0].toFixed(4), expChromSelection[1].toFixed(4)]
                                    console.log("newRetentionWindow from ResultsPlotsAndOptions: ", newRetentionWindow)
                                    console.log("selectedAnalyte from ResultsPlotsAndOptions: ", selectedAnalyte)
                                    recalculatePeakAreasLC(SUBMISSION_ID, selectedAnalyte.id, selectedAnalyte.name, newRetentionWindow)
                                        .then((response) => {
                                            console.log("response from recalculatePeakAreas: ", response)
                                            window.location = '/'
                                        })
                                }}
                            >
                                <BiReset className="mx-1 d-inline-block align-text-bottom" style={{ fontSize: '1.2rem' }} />
                                Re-Calculate Peak Areas
                            </button>
                        </div>
                        <hr />
                    </div>

                </div>
            </div>

        </div>
    )


}

function handleSampleDataChange(newData) {
    // renderChromatogram()
}


function updateChromatogram(chart, selectionRange, originalData) {
    let newData = originalData.filter((d) => {
        return d['x'] >= selectionRange[0] && d['x'] <= selectionRange[1]
    })
    chart.updateSeries([
        {
            data: originalData,
        },
        {
            name: "Selection-Fill",
            data: newData,
        }
    ])
}


function updateChromatogramOnStateChange(chart, title, analyteName) {
    chart?.updateOptions({
        title: {
            text: title + ` for ${analyteName}`,
        }
    })
    return chart

}



function renderChromatogram(selectedSample, data, divId, title, analyteName, setChromSelection) {
    console.log("selectedSample from renderChromatogram>>>>>>: ", selectedSample)
    let sampleFilename = data.find(d => d["sample_data"]["sample_id"] === selectedSample)["sample_data"]["sample_filename"]
    let sampleData, sampleIdx, rminIdx, rmaxIdx;
    if (title === EXP_CHROM_TITLE) {
        sampleIdx = data.findIndex(d => d["sample_data"]["sample_id"] === selectedSample)
        sampleData = data[sampleIdx]["exp_chrom_data"]
        // console.log("sampleData from renderChromatogram: ", sampleData)
        rminIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmin)
        rmaxIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmax) + 1
        // console.log("rminIdx from renderChromatogram-exp: ", sampleData.rmin, sampleData.values[rminIdx])
        // console.log("rmaxIdx from renderChromatogram-exp: ", sampleData.rmax, sampleData.values[rmaxIdx-1])
    } else if (title === ISTD_CHROM_TITLE) {
        sampleIdx = data.findIndex(d => d["sample_data"]["sample_id"] === selectedSample)
        sampleData = data[sampleIdx]["istd_chrom_data"]
        // console.log("sampleData from renderChromatogram: ", sampleData)
        rminIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmin)
        rmaxIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmax) + 1
        // console.log("rminIdx from renderChromatogram-istd: ", sampleData.rmin, sampleData.values[rminIdx])
        // console.log("rmaxIdx from renderChromatogram-istd: ", sampleData.rmax, sampleData.values[rmaxIdx-1])
    }

    // let rminIdx = data.findIndex((d) => d['x'] >= rmin) || data.length - 2
    // let rmaxIdx = data.findIndex((d) => d['x'] >= rmax) || data.length - 1

    // console.log("data from renderChromatogram: ", data)
    let colors = {
        exp: {
            fill: ['rgba(246, 100, 110, 0.4)'],
            stroke: ['#F6646E'],
        },
        istd: {
            fill: ['rgba(69, 150, 182, 0.4)'],
            stroke: ['#4596B6'],
        },
    }
    let options = {
        series: [
            {
                name: "Retention Time",
                data: sampleData.values.map((d) => [d['x'], d['y']]),
                type: 'line',
                // tooltip: {
                //     shared: false,
                //     intersect: true,
                //     custom: function({series, seriesIndex, dataPointIndex, w}) {
                //         return `<div class="card border-0">
                //                     <div class="card-header bg-dark" style="color: white;">
                //                         <span style='font-size: 1.2rem; font-weight: bold; margin: 0; padding: 0'>Point ${dataPointIndex+1}</span>
                //                     </div>
                //                     <div class="p-2 card" style="border-radius: 0px 0px 5px 5px;">
                //                         <span>Peak Area Ratio: ${series[seriesIndex][dataPointIndex]}</span>
                //                         <span>Calibration Concentration (uM): ${data.SCATTER_DUMMY_DATA[dataPointIndex].x}</span>
                //                     </div>
                //                 </div>`
                //     }
                // },
            },
            {
                name: "Selection-Fill",
                data: sampleData.values.map((d) => [d['x'], d['y']]).slice(rminIdx, rmaxIdx),
                type: 'area',
                fill: {
                    type: 'solid',
                    opacity: 0.5,
                    colors: '#ed3e3e'
                },
            }
        ],
        chart: {
            type: 'line',
            height: 600,
            zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: false
            },
            selection: {
                enabled: true,
            },
            toolbar: {
                show: true,
                autoSelected: 'selection',
                tools: {
                    // download: {
                    //     csv: true,
                    // },
                    selection: true,
                    zoom: false,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true,
                }
            },
            events: {
                selection: function (chart, e) {
                    setChromSelection([e.xaxis.min, e.xaxis.max])
                    console.log("min: ", e.xaxis.min, "max: ", e.xaxis.max)
                }
            }
        },
        stroke: {
            curve: 'straight',
            colors: divId === CHROM_EXP_ID ? colors.exp.stroke : colors.istd.stroke,
            width: 2,
        },
        dataLabels: {
            enabled: false
        },
        markers: {
            size: 1.5,
            strokeWidth: 0.5,
            colors: ["#f0e929"],
            strokeColors: ["#000000"]
        },
        title: {
            text: title + ` for ${analyteName}` + ` (${sampleFilename} [ID#${selectedSample}])`,
            align: 'left',
        },
        fill: {
            type: 'solid',
            colors: divId === CHROM_EXP_ID ? colors.exp.fill : colors.istd.fill,
            opacity: 0.8,
        },
        yaxis: {
            title: {
                text: 'Intensity'
            },
            labels: {
                formatter: function (value) {
                    return value.toFixed(2)
                }
            }
        },
        xaxis: {
            type: 'numeric',
            tickPlacement: 'on',
            // tickAmount: data.length/2,
            title: {
                text: 'Retention Time (min)'
            }
        },
        legend: {
            show: false,
        },
        tooltip: {
            x: {
                formatter: (value) => `${parseFloat(value).toFixed(4)} min`,
            },
            y: {
                title: {
                    formatter: (seriesName) => `Intensity`,
                }
            }
        }


    }

    let chart = new ApexCharts(document.getElementById(divId), options);
    chart.render();
    chartTitle = options.title.text
    console.log("chart from renderChromatogram: ", chart, chartTitle)

    return chart;

}




function renderCalCurve(data, divId, analyteName) {

    // console.log("data from renderCalCurve: ", data)
    let options = {
        series: [{
            name: 'Calibration Points',
            type: 'scatter',
            data: data.cal_points
        }, {
            name: 'Best Fit Line',
            type: 'line',
            data: data.best_fit_line
        }],
        chart: {
            height: 675,
            type: 'line',
        },
        stroke: {
            colors: ["#F6646E"]
        },
        fill: {
            type: 'solid',
        },
        markers: {
            // size: [10, 0]
            discrete: data.cal_points.map((d, i) => {
                return {
                    seriesIndex: 0,
                    dataPointIndex: i,
                    fillColor: CAL_CURVE_MARKER_COLOR,
                    size: DEFAULT_CAL_CURVE_MARKER_SIZE,
                }
            })
        },
        tooltip: {
            shared: false,
            intersect: true,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return `<div class="card border-0">
                            <div class="card-header bg-dark" style="color: white;">
                                <span style='font-size: 1.2rem; font-weight: bold; margin: 0; padding: 0'>Point ${dataPointIndex + 1}</span>
                            </div>
                            <div class="p-2 card" style="border-radius: 0px 0px 5px 5px;">
                                <span>Peak Area Ratio: ${series[seriesIndex][dataPointIndex]}</span>
                                <span>Calibration Concentration (uM): ${data.cal_points[dataPointIndex].x}</span>
                            </div>
                        </div>`
            }
        },
        legend: {
            show: false
        },
        yaxis: {
            title: {
                text: 'Peak Area Ratio'
            },
            labels: {
                formatter: function (value) {
                    return value.toFixed(4)
                }
            }
        },
        xaxis: {
            type: 'numeric',
            title: {
                text: 'Calibration Concentration (uM)'
            }
        },
        title: {
            text: `Calibration Curve for ${analyteName}`,
            align: 'left',
        },
    };

    let chart = new ApexCharts(document.getElementById(divId), options);
    chart.render();

    return chart;

}


function fetchSampleChromatogram() {
    return {
        exp: [{ "x": 0.0, "y": 680.0 }, { "x": 0.05446666666666666, "y": 1080.0 }, { "x": 0.10893333333333333, "y": 880.0 }, { "x": 0.16339999999999996, "y": 1000.0 }, { "x": 0.21785, "y": 1040.0 }, { "x": 0.27231666666666665, "y": 1280.0 }, { "x": 0.3267833333333333, "y": 520.0 }, { "x": 0.38125, "y": 880.0 }, { "x": 0.43571666666666664, "y": 680.0 }, { "x": 0.49018333333333336, "y": 600.0 }, { "x": 0.5446333333333333, "y": 760.0 }, { "x": 0.5991, "y": 720.0 }, { "x": 0.6535666666666666, "y": 720.0 }, { "x": 0.7080333333333333, "y": 1120.0 }, { "x": 0.7625, "y": 480.0 }, { "x": 0.8169666666666667, "y": 11880.0 }, { "x": 0.8714333333333333, "y": 45160.0 }, { "x": 0.9258833333333332, "y": 60760.0 }, { "x": 0.98035, "y": 65680.0 }, { "x": 1.0348166666666667, "y": 69480.0 }, { "x": 1.0892833333333334, "y": 69920.0 }, { "x": 1.14375, "y": 67080.0 }, { "x": 1.1982166666666667, "y": 67360.0 }, { "x": 1.2526666666666666, "y": 69680.0 }, { "x": 1.3071333333333333, "y": 65600.0 }, { "x": 1.3616, "y": 65960.0 }, { "x": 1.4160666666666666, "y": 63000.0 }, { "x": 1.4705333333333332, "y": 55040.0 }, { "x": 1.525, "y": 49760.0 }, { "x": 1.5794666666666666, "y": 43080.0 }, { "x": 1.633916666666667, "y": 35040.0 }, { "x": 1.6883833333333331, "y": 23680.0 }, { "x": 1.74285, "y": 14400.0 }, { "x": 1.797316666666667, "y": 7520.0 }, { "x": 1.8517833333333331, "y": 5800.0 }, { "x": 1.90625, "y": 4280.0 }, { "x": 1.9607166666666669, "y": 4120.0 }, { "x": 2.0151666666666666, "y": 2400.0 }, { "x": 2.0696333333333334, "y": 3160.0 }, { "x": 2.1241, "y": 2080.0 }, { "x": 2.1785666666666668, "y": 1760.0 }, { "x": 2.233033333333333, "y": 1960.0 }, { "x": 2.2875, "y": 1840.0 }, { "x": 2.34195, "y": 1600.0 }, { "x": 2.396416666666666, "y": 1640.0 }, { "x": 2.450883333333333, "y": 1400.0 }, { "x": 2.50535, "y": 1360.0 }, { "x": 2.559816666666667, "y": 1280.0 }, { "x": 2.6142833333333333, "y": 1320.0 }, { "x": 2.66875, "y": 1000.0 }, { "x": 2.7232, "y": 1600.0 }, { "x": 2.7776666666666667, "y": 920.0 }, { "x": 2.832133333333333, "y": 1080.0 }, { "x": 2.8866, "y": 1640.0 }, { "x": 2.9410666666666665, "y": 1200.0 }],
        istd: [{ "x": 0.0, "y": 560.0 }, { "x": 0.05446666666666666, "y": 680.0 }, { "x": 0.10893333333333333, "y": 920.0 }, { "x": 0.16339999999999996, "y": 360.0 }, { "x": 0.21785, "y": 840.0 }, { "x": 0.27231666666666665, "y": 600.0 }, { "x": 0.3267833333333333, "y": 600.0 }, { "x": 0.38125, "y": 560.0 }, { "x": 0.43571666666666664, "y": 560.0 }, { "x": 0.49018333333333336, "y": 680.0 }, { "x": 0.5446333333333333, "y": 640.0 }, { "x": 0.5991, "y": 720.0 }, { "x": 0.6535666666666666, "y": 680.0 }, { "x": 0.7080333333333333, "y": 1160.0 }, { "x": 0.7625, "y": 480.0 }, { "x": 0.8169666666666667, "y": 12560.0 }, { "x": 0.8714333333333333, "y": 45040.0 }, { "x": 0.9258833333333332, "y": 57560.0 }, { "x": 0.98035, "y": 63920.0 }, { "x": 1.0348166666666667, "y": 67000.0 }, { "x": 1.0892833333333334, "y": 68080.0 }, { "x": 1.14375, "y": 65680.0 }, { "x": 1.1982166666666667, "y": 69360.0 }, { "x": 1.2526666666666666, "y": 62920.0 }, { "x": 1.3071333333333333, "y": 63200.0 }, { "x": 1.3616, "y": 60760.0 }, { "x": 1.4160666666666666, "y": 55640.0 }, { "x": 1.4705333333333332, "y": 54800.0 }, { "x": 1.525, "y": 48280.0 }, { "x": 1.5794666666666666, "y": 40320.0 }, { "x": 1.633916666666667, "y": 34080.0 }, { "x": 1.6883833333333331, "y": 23920.0 }, { "x": 1.74285, "y": 14960.0 }, { "x": 1.797316666666667, "y": 8680.0 }, { "x": 1.8517833333333331, "y": 4680.0 }, { "x": 1.90625, "y": 3400.0 }, { "x": 1.9607166666666669, "y": 3080.0 }, { "x": 2.0151666666666666, "y": 3080.0 }, { "x": 2.0696333333333334, "y": 2320.0 }, { "x": 2.1241, "y": 2520.0 }, { "x": 2.1785666666666668, "y": 1680.0 }, { "x": 2.233033333333333, "y": 1720.0 }, { "x": 2.2875, "y": 1880.0 }, { "x": 2.34195, "y": 1520.0 }, { "x": 2.396416666666666, "y": 800.0 }, { "x": 2.450883333333333, "y": 920.0 }, { "x": 2.50535, "y": 1200.0 }, { "x": 2.559816666666667, "y": 800.0 }, { "x": 2.6142833333333333, "y": 760.0 }, { "x": 2.66875, "y": 880.0 }, { "x": 2.7232, "y": 920.0 }, { "x": 2.7776666666666667, "y": 720.0 }, { "x": 2.832133333333333, "y": 760.0 }, { "x": 2.8866, "y": 720.0 }, { "x": 2.9410666666666665, "y": 800.0 }]
    }
}


function findClosestIndex(array, target) {
    if (array.length === 0) return -1
    let closestIdx = 0
    let closestDiff = Math.abs(target - array[0])
    for (let i = 1; i < array.length; i++) {
        let diff = Math.abs(target - array[i])
        if (diff < closestDiff) {
            closestIdx = i
            closestDiff = diff
        }
    }
    return closestIdx
}